export enum MovementLocationType {
  YARD = 'YARD',
  DRY_VACANCY = 'DRY_VACANCY',
  WET_VACANCY = 'WET_VACANCY',
  NAVIGATION = 'NAVIGATION',
  MOORED = 'MOORED'
}
